
export const fetchRegions = async () => {
  try {
    const res = await fetch("https://psgc.gitlab.io/api/regions/")
    return await res.json()
  } catch (e) {
    console.error("Error fetching regions:", e)
    return []
  }
}

export const fetchProvincesForRegions = async (regionCodes = []) => {
  if (!regionCodes.length) return []
  try {
    const allProvinces = await Promise.all(
      regionCodes.map(async (code) => {
        const res = await fetch(
          `https://psgc.gitlab.io/api/regions/${code}/provinces/`
        )
        return res.json()
      })
    )
    return allProvinces.flat()
  } catch (e) {
    console.error("Error fetching provinces:", e)
    return []
  }
}

export const fetchMunicipalitiesForProvinces = async (provinceCodes = []) => {
  if (!provinceCodes.length) return []
  try {
    const allMunicipalities = await Promise.all(
      provinceCodes.map(async (code) => {
        const res = await fetch(
          `https://psgc.gitlab.io/api/provinces/${code}/cities-municipalities/`
        )
        return res.json()
      })
    )
    return allMunicipalities.flat()
  } catch (e) {
    console.error("Error fetching municipalities:", e)
    return []
  }
}

export const fetchBarangaysForMunicipalities = async (municipalityCodes = []) => {
  if (!municipalityCodes.length) return []
  try {
    const allBarangays = await Promise.all(
      municipalityCodes.map(async (code) => {
        const res = await fetch(
          `https://psgc.gitlab.io/api/cities-municipalities/${code}/barangays/`
        )
        return res.json()
      })
    )
    return allBarangays.flat()
  } catch (e) {
    console.error("Error fetching barangays:", e)
    return []
  }
}
